export default __webpack_public_path__ + "static/media/fem_4.08b03811.png";